// extracted by mini-css-extract-plugin
export default {"listItem":"xMcmq","header":"DQ9hS","headerDate":"ogzmh","headerUser":"XujnK","headerArrow":"rKbEW","content":"W7q0f","actionButtons":"mylB6","changesList":"UwyTE"};